import React, { useMemo } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { Tooltip } from "antd";
import FileItem from "components/FileItem";

interface AsideLinkProps<T> {
    item: T & { fileType?: string; fileName?: string };
    desc?: string;
    active?: boolean;
    onClick: () => void;
    finished?: boolean;
}

export default function AsideLink<T>({
    item,
    active,
    onClick
}: AsideLinkProps<T>) {
    const filename = item.fileName || "";
    const ext = useMemo(() => {
        const ext = item.fileType;
        return ext ? `.${ext}` : "";
    }, [filename]);

    const title = useMemo(() => {
        const append = filename.length > 10 ? "..." : "";
        return filename.substring(0, 10).replaceAll(ext, "") + append;
    }, [ext, filename]);

    return (
        <div
            className={classNames(styles.root, { [styles.active]: active })}
            onClick={onClick}>
            <div className={styles.main}>
                <FileItem
                    style={{ width: "100%" }}
                    text={
                        <Tooltip title={item.fileName}>
                            <span className={styles.title}>
                                {title}
                                {ext}
                            </span>
                        </Tooltip>
                    }
                    fileType={item.fileType || ""}
                />
            </div>
        </div>
    );
}
